import React, { Component } from "react";
import {
    FormGroup,
    ControlLabel,
    Glyphicon, 
    Tooltip, 
    OverlayTrigger,
    Col,
    Panel
   } from "react-bootstrap";
   import { invokeApig } from '../../libs/awsLib';
   import Select from 'react-select';
   
export default class Tag extends Component {
   
    constructor(props) {
      super(props);
      this.defaultOptions = [
        { id: 'tag1', label: 'Tag1'},
        { id: 'tag2', label: 'Tag2'},
        { id: 'tag3', label: 'Tag3'}
        ];
      this.state = {
        isLoading: true,
        removeSelected: true,
        disabled: false,
        stayOpen: false,
        value: [],
        options: this.defaultOptions
      };
  }

    handleChange = (event) => {
      this.setState({
        [event.target.id]: event.target.value
      });
      this.props.onChangeAddress(this.state);
    }

    getTags() {
      return invokeApig({
        path: "/unit/tags"
      });
    }
  
    async showTags() {
    const options = [];
    try {
        this.setState({ options: [] });
        const result = await this.getTags();
        result.map((tag) => {
          options.push({
            id: tag,
            label: tag
          });
          return null;
        });
      } catch (e) {
        alert(e);
      }
      this.setState({ isLoading: false, options: options });
    }
    render(){
      const { disabled, stayOpen, value, options } = this.state;
        return(
          <Panel>
            <Panel.Heading>#Tag</Panel.Heading>
    	    <Panel.Body>
    	    <FormGroup controlId="state">
              <Col componentClass={ControlLabel} sm={3}>
                Nombre Grupo{' '}
                <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al Grupo asociado al vehículo.</Tooltip>}>
                  <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
                </OverlayTrigger>
              </Col>
              <Col sm={9}>
              <Select
                className="tagSelect"
                closeOnSelect={!stayOpen}
                disabled={disabled}
                multi={true}
                onChange={this.handleSelectChange}
                options={options}
                placeholder="Click para ver Tags registrados"
                removeSelected={this.state.removeSelected}
                valueKey="id"
                labelKey="label"
                value={value}
	            />
              </Col>
            </FormGroup>
            
            
    	    </Panel.Body>
    	  </Panel>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/tag/Tag.js